export const DEFAULT_COLORS = {
  white: { off: "#F7F6F5", default: "#FFFFFF" },
  black: { 900: "#302D28", 800: "#454545", 700: "#595959", 600: "#737373", default: "#000000" },
  grey: {
    900: "#898683",
    800: "#969290",
    700: "#ABA8A6",
    600: "#B7B5B4",
    500: "#CEC9C6",
    400: "#E0DDDA",
    300: "#E6E4E1",
    200: "#ECEBE9"
  },
  blue: {
    900: "#202649",
    800: "#243191",
    700: "#3341A2",
    600: "#485CC2",
    500: "#2458CE",
    400: "#4675E4",
    300: "#7298E8",
    200: "#9FBEFF",
    100: "#C2D6FF"
  },
  green: {
    900: "#003534",
    800: "#054746",
    700: "#335D5D",
    600: "#56817E",
    500: "#3D9974",
    400: "#9AE674",
    300: "#AEEB90",
    200: "#C2F0AC",
    100: "#DBFDCB"
  },
  purple: { 400: "#B48CFA", 300: "#C1A0FB", 200: "#CFB5FC", 100: "#DFCCFF" },
  red: { 400: "#EB4646", 300: "#EF5A5E", 200: "#F37680", 100: "#FE99A1" },
  orange: { 400: "#FF7628", 300: "#FF8951", 200: "#FFA073", 100: "#F4BD98" },
  yellow: { 400: "#F8DE50", 300: "#F9E26F", 200: "#FBEB94", 100: "#FFF4B9" },
  bgColor: "#F7F6F5" // TODO remove this
};

export const colors = {
  primary: DEFAULT_COLORS.orange[400],
  border: DEFAULT_COLORS.grey[600],

  ...DEFAULT_COLORS
};
